<template>
  <div class="uk-grid-medium" uk-grid>
    <div class="uk-width-5-5">
      <div class="d-flex">
        <nav id="breadcrumbs" class="mb-3">
          <ul>
            <li>
              <router-link :to="{ name: 'company.dashboard' }">
                <i class="uil-home-alt"></i>
              </router-link>
            </li>
            <li>{{ $t("certificate_template.management") }}</li>
            <li>{{ $t("certificate_template.edit") }}</li>
          </ul>
        </nav>
      </div>

      <template v-if="errorMessages">
        <div
          v-for="(error, index) in errorMessages"
          :key="index"
          class="uk-alert-danger"
          uk-alert
        >
          <a class="uk-alert-close" uk-close></a>
          <p style="color: red">
            <i class="uil-exclamation-triangle"></i> {{ error }}
          </p>
        </div>
      </template>
      <div v-if="successMessage" class="uk-alert-success" uk-alert>
        <a class="uk-alert-close" uk-close></a>
        <p style="color: green">
          <i class="uil-exclamation-triangle"></i> {{ successMessage }}
        </p>
      </div>
      <div class="card">
        <form class="card-body">
          <div class="row">
            <div class="col-xl-12 m-auto">
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="course_title"
                  >{{ $t("certificate_template.name")
                  }}<span class="required">*</span></label
                >
                <div class="col-md-9">
                  <input
                    v-model="template.name"
                    type="text"
                    class="form-control"
                    id="course_title"
                    name="title"
                    :placeholder="$t('certificate_template.name')"
                    required=""
                  />
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="status">
                  {{ $t("general.status") }}</label
                >
                <div class="col-md-9">
                  <toggle-button
                    id="status"
                    v-if="updateStatus"
                    :width="80"
                    v-model="template.status_id"
                    color="#ae71ff"
                    :sync="true"
                    :labels="{
                      checked: $t('general.active'),
                      unchecked: $t('general.passive'),
                    }"
                  />
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="logo"
                  >{{ $t("certificate_template.image")
                  }}<span class="required">*</span></label
                >
                <div class="col-md-9">
                  <input
                    type="file"
                    class="d-none"
                    id="cover_photo_input"
                    accept="image/*"
                    @change="processFile($event)"
                  />
                  <button
                    @click="inputClick()"
                    type="button"
                    ref="templateImageButton"
                    class="btn btn-default btn-icon-label"
                  >
                    <span class="btn-inner--icon">
                      <i class="uil-image"></i>
                    </span>
                    <span class="btn-inner--text">{{
                      $t("certificate_template.change")
                    }}</span>
                  </button>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="top_center_logo_input">
                  {{ $t("certificate_template.top_center_logo") }}
                </label>
                <div class="col-md-9">
                  <input id="top_center_logo_input" type="file" class="d-none" accept="image/png,image/jpeg,image/webp"
                         @change="processLogoFile($event, 'top_center')" />
                  <button type="button" class="btn btn-default btn-icon-label logo-upload-button" :style="{ width: logoButtonWidth, height: logoButtonHeight }" @click="inputLogoClick('top_center')">
                    <span class="btn-inner--icon"><i class="uil-image"></i></span>
                    <span class="btn-inner--text">{{ $t("certificate_template.upload_logo") }}</span>
                  </button>
                  <button v-if="topCenterLogoPreview" type="button" class="btn btn-light ml-2"
                          @click="clearLogo('top_center')">
                    {{ $t("general.remove") }}
                  </button>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="bottom_left_logo_input">
                  {{ $t("certificate_template.bottom_left_logo") }}
                </label>
                <div class="col-md-9">
                  <input id="bottom_left_logo_input" type="file" class="d-none" accept="image/png,image/jpeg,image/webp"
                         @change="processLogoFile($event, 'bottom_left')" />
                  <button type="button" class="btn btn-default btn-icon-label logo-upload-button" :style="{ width: logoButtonWidth, height: logoButtonHeight }" @click="inputLogoClick('bottom_left')">
                    <span class="btn-inner--icon"><i class="uil-image"></i></span>
                    <span class="btn-inner--text">{{ $t("certificate_template.upload_logo") }}</span>
                  </button>
                  <button v-if="bottomLeftLogoPreview" type="button" class="btn btn-light ml-2"
                          @click="clearLogo('bottom_left')">
                    {{ $t("general.remove") }}
                  </button>
                </div>
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="show_date">
                  {{ $t("certificate_template.show_date") }}
                </label>
                <div class="col-md-9">
                  <toggle-button id="show_date" :width="80" v-model="show_date" color="#ae71ff" :sync="true"
                    :labels="{ checked: $t('general.active'), unchecked: $t('general.passive') }" />
                </div>
              </div>
              <div class="certificate-container position-relative mb-3">
                <div class="certificate template2">
                  <div class="water-mark-overlay"></div>
                  <div class="certificate-header">
                    <img
                      v-if="topCenterLogoPreview"
                      :src="topCenterLogoPreview"
                      class="template-logo template-logo-top-center"
                      alt=""
                    />
                  </div>
                  <div class="certificate-body">
                    <p class="certificate-title">
                      <strong>{egitim.adi}</strong>
                    </p>
                    <h1>{{ $t("certificate.name") }}</h1>
                    <p class="student-name">
                      <span>{{ $t("certification.mr") }}</span>
                      {k.adi} {k.soyadi}
                    </p>
                    <div class="certificate-content">
                      <div class="about-certificate">
                        <p>
                          {{ $t("certificate.body_text_example") }}
                        </p>
                      </div>
                    </div>
                    <div class="certificate-footer">
                      <div class="row">
                        <div class="col-md-12 text-center">
                          <p>{{ $t("certificate.certifying_name") }}</p>
                          <span>{{ $t("certificate.certifying_title") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span v-if="show_date" class="certificate-date">{tamamlanma.tarihi}</span>
                  <img v-if="bottomLeftLogoPreview" :src="bottomLeftLogoPreview"
                       class="template-logo template-logo-bottom-left" alt="" />
                </div>
                <img
                  :src="template.cover_image_link"
                  class="certificate-background-img logoarea"
                  alt=""
                />
              </div>
              <div class="form-group row mb-3">
                <label class="col-md-3 col-form-label" for="second_page_photo_input">
                  {{ $t("certificate_template.second_page_image") }}
                </label>
                <div class="col-md-9">
                  <input
                    id="second_page_photo_input"
                    type="file"
                    class="d-none"
                    accept="image/*"
                    @change="processSecondPageFile($event)"
                  />
                  <button type="button" class="btn btn-default btn-icon-label" @click="inputSecondPageClick()">
                    <span class="btn-inner--icon"><i class="uil-image"></i></span>
                    <span class="btn-inner--text">{{ $t("certificate_template.change") }}</span>
                  </button>
                </div>
              </div>
              <div v-if="secondPagePreview || template.second_page_image_link"
                   class="certificate-container second-page-preview position-relative mb-3">
                <img :src="secondPagePreview || template.second_page_image_link"
                     class="certificate-background-img" alt="" />
              </div>
            </div>
          </div>
          <div class="uk-card-footer float-right pb-0 pr-0">
            <button
              class="uk-button uk-button-primary small"
              type="button"
              @click="saveForm()"
            >
              <i class="icon-feather-arrow-right"></i> {{ $t("general.save") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import store from "@/core/services";
import moment from "moment";
import module, {
  BASE_URL,
  UPDATE_ITEM,
  ITEM,
  GET_ITEM,
  MODULE_NAME,
  ERROR,
} from "@/core/services/store/certificate_template.module";
export default {
  name: "CertificateTemplatesEdit",
  components: {},
  data() {
    return {
      successMessage: null,
      cover_image: null,
      second_page_image: null,
      secondPagePreview: null,
      top_center_logo: null,
      topCenterLogoPreview: null,
      bottom_left_logo: null,
      bottomLeftLogoPreview: null,
      remove_top_center_logo: false,
      remove_bottom_left_logo: false,
      show_date: false,
      logoButtonWidth: null,
      logoButtonHeight: null,
      errorMessages: [],
    };
  },
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }
    registerStoreModule(MODULE_NAME, module);
  },
  computed: {
     template: {
      get() {
        return store.getters[MODULE_NAME + "/" + ITEM];
      },
      set() {},
    },
    updateStatus(){
      if(this.template == null)return false
      return true
    },
    error: {
      get() {
        return store.getters[MODULE_NAME + "/" + ERROR];
      },
      set() {},
    },
  },
  methods: {
    saveForm() {
      let self = this.template;
      let formData = new FormData();
      this.errorMessages = [];
      if (self.name.length < 2) {
            this.scrollToTop();
        this.errorMessages.push(
          this.$t("validation.required_field").replace(
            ":NAME",
            this.$t("certificate_template.name")
          )
        );
        return false;
      }
      formData.append("name", self.name);
      if(this.cover_image != null)formData.append("cover_image", this.cover_image);
      if(this.second_page_image != null)formData.append("second_page_image", this.second_page_image);
      if(this.top_center_logo != null)formData.append("top_center_logo", this.top_center_logo);
      if(this.bottom_left_logo != null)formData.append("bottom_left_logo", this.bottom_left_logo);
      formData.append("remove_top_center_logo", this.remove_top_center_logo ? "1" : "0");
      formData.append("remove_bottom_left_logo", this.remove_bottom_left_logo ? "1" : "0");
      formData.append("show_date", this.show_date ? "1" : "0");
      formData.append("status_id", self.status_id == true ? "1" : "0");
      store
        .dispatch(MODULE_NAME + "/" + UPDATE_ITEM, {
          url: BASE_URL+"/update/"+this.$route.params.id,
          contents: formData,
        })
        .then(() => {
          this.scrollToTop();
          if (!this.error) {
            this.successMessage = this.$t("general.successfully_created");
            this.$router.push({ name: "company.certificate_template.list" });
          }else this.errorMessages.push(this.error)
        });
    },
    getTemplateItem() {
      this.$store.dispatch(MODULE_NAME + "/" + GET_ITEM, {
        url: BASE_URL +"/"+ this.$route.params.id,
      });
    },
    processFile(event) {
      this.cover_image = event.target.files[0];
      let blob = URL.createObjectURL(this.cover_image);
      let imageHolder = window.$(".logoarea");
      imageHolder.attr("src", blob);
    },
    inputClick() {
      window.$("#cover_photo_input").click();
    },
    processSecondPageFile(event) {
      this.second_page_image = event.target.files[0] || null;
      this.secondPagePreview = this.second_page_image
        ? URL.createObjectURL(this.second_page_image)
        : null;
    },
    inputSecondPageClick() {
      window.$("#second_page_photo_input").click();
    },
    processLogoFile(event, position) {
      const file = event.target.files[0] || null;
      const fileKey = position + "_logo";
      const previewKey = position === "top_center" ? "topCenterLogoPreview" : "bottomLeftLogoPreview";
      const removeKey = "remove_" + position + "_logo";
      this[fileKey] = file;
      this[previewKey] = file ? URL.createObjectURL(file) : null;
      this[removeKey] = false;
    },
    inputLogoClick(position) {
      window.$("#" + position + "_logo_input").click();
    },
    clearLogo(position) {
      const fileKey = position + "_logo";
      const previewKey = position === "top_center" ? "topCenterLogoPreview" : "bottomLeftLogoPreview";
      const removeKey = "remove_" + position + "_logo";
      this[fileKey] = null;
      this[previewKey] = null;
      this[removeKey] = true;
      const input = document.getElementById(position + "_logo_input");
      if (input) input.value = "";
    },
    syncLogoButtonWidth() {
      this.$nextTick(() => {
        const templateButton = this.$refs.templateImageButton;
        this.logoButtonWidth = templateButton ? templateButton.offsetWidth + "px" : null;
        this.logoButtonHeight = templateButton ? templateButton.offsetHeight + "px" : null;
      });
    },
    resetMessages() {
      this.errorMessages = [];
      this.successMessage = null;
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    this.getTemplateItem();
    this.syncLogoButtonWidth();
  },
  watch: {
    "$i18n.locale": function() {
      this.syncLogoButtonWidth();
    },
    template: {
      handler(value) {
        if (!value) return;
        value.status_id = value.status_id === true || value.status_id === 1 || value.status_id === "1";
        this.show_date = value.show_date === true || value.show_date === 1 || value.show_date === "1";
        if (!this.top_center_logo && !this.remove_top_center_logo) {
          this.topCenterLogoPreview = value.top_center_logo_link || null;
        }
        if (!this.bottom_left_logo && !this.remove_bottom_left_logo) {
          this.bottomLeftLogoPreview = value.bottom_left_logo_link || null;
        }
      },
      immediate: true,
    },
    successMessage: function () {
      this.debouncedResetValues();
    },
    errorMessages: function () {
      this.debouncedResetValues();
    },
  },
  created: function () {
    this.debouncedResetValues = window._.debounce(this.resetMessages, 2000);
  },
};
</script>
<style scoped>
input[type="button"],
input[type="submit"],
span.btn,
.btn {
  display: inline-block;
}
.logo-upload-button,
.logo-upload-button .btn-inner--text {
  white-space: nowrap;
}
.certificate-background-img {
  top: 0px;
  height: 100%;
  width: 100%;
  left: 0px;
  bottom: 0px;
  right: 0px;
  position: absolute;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 1;
}
.second-page-preview {
  aspect-ratio: 1.84 / 1;
}
.certificate.template2::after {
  background-image: unset !important;
  background-color: transparent !important;
}
.certificate.template2 {
  z-index: 101;
  position: relative;
}
.template-logo {
  position: absolute;
  z-index: 3;
  object-fit: contain;
}
.certificate-header {
  position: relative;
  height: 90px;
}
.template-logo-top-center {
  top: 8px;
  left: 50%;
  width: 150px;
  height: 60px;
  transform: translateX(-50%);
}
.template-logo-bottom-left {
  left: 32px;
  bottom: 28px;
  width: 170px;
  height: 60px;
}
.certificate-date {
  position: absolute;
  right: 32px;
  bottom: 42px;
  z-index: 3;
  font-size: 16px;
}
</style>
